import { Card } from '@mui/material';

const SoothCard = ({ sx = {}, children }) => {
  return (
    <Card
      sx={({ shape, palette }) => ({
        p: 2,
        backgroundColor: palette.secondary.main,
        borderRadius: shape.borderRadius / 4,
        boxShadow: 'none',
        ...sx,
      })}
    >
      {children}
    </Card>
  );
};

export default SoothCard;
